import { displayDateFormat, storageDateFormat, longDisplayDateFormat } from '@/core';
import moment from 'moment';

function displayDateFormatter(date, longFormat) {
	if (!date) return '';
	if (longFormat)
		return moment(date, storageDateFormat).format(longDisplayDateFormat);
	else
		return moment(date, storageDateFormat).format(displayDateFormat);
}

export default displayDateFormatter;